import { LeaderboardList } from "@/pages/participant/LeaderboardPage";
import { PageTitle } from "./AdminLayout";

export default function AdminLeaderboard() {
  return (
    <div className="max-w-2xl">
      <PageTitle title="Leaderboard" desc="Peringkat berdasarkan jumlah tiket COMPLETED (dikonfirmasi keeper)." />
      <LeaderboardList endpoint="/admin/leaderboard" />
    </div>
  );
}
